<div class="content-container">
    <nav class="navbar sticky-top">
        <div class="d-grid gap-2 d-flex navbar-brand">
          <button (click)="this.location.back();" type="button" ngbTooltip="Back" placement="bottom" class="btn btn-primary backBtn" aria-label="Back">
            <fa-icon [icon]="faAngleLeft"></fa-icon>
          </button>
          <h2 class="mobileHeading">Templates</h2>
        </div>
    </nav>
    <div class="row mt-3">
      <div class="col-12 mb-3">
        <ul ngbNav #nav="ngbNav" class="nav-tabs" [activeId]="getCurrentTab()">
          <!-- Proposals -->
          <li ngbNavItem="PROPOSALS">
            <a ngbNavLink>Proposals</a>
            <ng-template ngbNavContent>
              <app-group-template></app-group-template>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="nav" class="mt-2"></div>
      </div>
    </div>
  </div>
